import { DateTime } from "luxon";
import React from "react";

export const TransactedAtComponent = (props: { value: DateTime }) => (
  <>{props.value.toLocaleString(DateTime.DATETIME_MED)}</>
);
